module.exports = __webpack_public_path__ + "static/img/Testimonials2 - Copy.4a880c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Testimonials2 - Copy.png
// module id = 1603
// module chunks = 5